import { apiAction } from '../../../shared/store/apiAction';
import * as api from '../api';

import { fetchColumnHeadersTypes } from './types';

export const fetchColumnHeaders = apiAction({
  types: fetchColumnHeadersTypes,
  apiAction: api.fetchColumnHeaders,
});
